export default __webpack_public_path__ + "static/media/updateavailable.e59e71df.svg";